import { requestByPOST } from 'lib/requests'
import { buildPathParams } from 'lib/utils/url'

const END_POINTS = {
  REFUND_WALLET: '/refund-on-hold/{hash}/wallet',
}

export function refundWalletRequest(params) {
  return requestByPOST({
    ...params,
    endpoint: buildPathParams(END_POINTS.REFUND_WALLET, params),
  })
}
